module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.submitPending) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n    přihlašování...\n  ")]) : _vm._e(), _vm._v(" "), (_vm.displayError) ? _c('div', {
    staticClass: "col-sm-12 error-box"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n    " + _vm._s(_vm.displayError) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-600125f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TokenLogin.vue
// module id = 323
// module chunks = 1 2